export const getPageDirectoryStyles = () => ({
  directoryItem: {
    marginTop: 25,
  },
});
